<template>
  <div class="mach-cone-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>sin(μ) = 1 / M (Mach Number)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Jet -->
          <g :transform="`translate(${jetX}, 120)`">
             <path d="M 0,-5 L 20,0 L 0,5 Z" fill="#fff" />
             <path d="M -5,-2 L 5,0 L -5,2 Z" fill="#ff4757" />
          </g>

          <!-- Wavefronts -->
          <circle v-for="w in wavefronts" :key="w.id" :cx="w.x" :cy="120" :r="w.r" fill="none" :stroke="isSupersonic ? 'rgba(0, 210, 255, 0.4)' : '#888'" />

          <!-- Mach Cone Lines -->
          <g v-if="isSupersonic">
             <line :x1="machStart" y1="120" :x2="jetX" :y2="120 - machY" stroke="#00d2ff" stroke-width="2" />
             <line :x1="machStart" y1="120" :x2="jetX" :y2="120 + machY" stroke="#00d2ff" stroke-width="2" />
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>当前马赫数 M: {{ mach.toFixed(2) }}</label>
              <div class="value" :style="{ color: isSupersonic ? '#00d2ff' : '#888' }">{{ isSupersonic ? '超音速 (激波形成)' : '亚音速' }}</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节速度</label>
             <el-slider v-model="mach" :min="0.1" :max="3" step="0.1" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>当波源的速度超过波速（声速）时，波源发射出的波阵面会在后方叠加并汇聚成一个圆锥形的包络面，这被称为**马赫锥**。对于观测者来说，这表现为强烈的**激波**（音爆）。马赫数 $M$ 越大，圆锥的张角越小。这种现象也类比于带电粒子速度超过光速时的**切连科夫辐射**。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MachConeViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      mach: 1.2,
      jetX: 0,
      wavefronts: [],
      timer: null
    }
  },
  computed: {
    isSupersonic() { return this.mach > 1; },
    machY() {
       if (!this.isSupersonic) return 0;
       // sin(mu) = 1/M -> tan(mu) = 1/sqrt(M^2 - 1)
       // Let width be 200, height = width * tan(mu)
       return 100 * (1 / Math.sqrt(this.mach * this.mach - 1));
    },
    machStart() { return this.jetX - 100; }
  },
  methods: {
    update() {
      const speed = this.mach * 2;
      this.jetX += speed;
      if (this.jetX > 400) this.jetX = 0;

      // Periodically add wavefronts
      if (Math.random() > 0.9) {
         this.wavefronts.push({ id: Date.now(), x: this.jetX, r: 0 });
      }

      this.wavefronts.forEach(w => {
         w.r += 2; // Sound travels at constant 1.0 (relative)
      });
      this.wavefronts = this.wavefronts.filter(w => w.r < 300);

      this.timer = requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.mach-cone-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
